import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { SalaryDtos } from "../../../../Component/Model/Dto/Salaries";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { currencyFormatterNoDecimal } from "../../../../Helpers/CurrencyFormatter";

interface EmployeeSalariesRow {
    Id:                     number;
    IdentificationNumber:   string;
    EmployeeCode:           string;
    FirstName:              string;
    LastName:               string;
    Race:                   string;
    Gender:                 string;
    Disabled:               string;
    TotalSalary:            string;
    Actions:                ActionType[];
}

export interface EmployeeSalariesTable {
    columns: Array<TableColumn>;
    rows: Array<EmployeeSalariesRow>;
}

export function EmployeeSalariesWithActionsTableMapper(dataObject: SalaryDtos.SalarySearchRow[], handleEdit: (id: number) => void, isEditable: boolean): EmployeeSalariesTable | undefined {
    const columns = [
        { Header: 'ID Number', accessor: 'IdentificationNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Name', accessor: 'FirstName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Surame', accessor: 'LastName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Race', accessor: 'Race', id:'RaceId', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Gender', accessor: 'Gender', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Disabled', accessor: 'Disabled', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Total Salary', accessor: 'TotalSalary', Cell: ({ value }: any) => <DefaultCell value={value}/>, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item: SalaryDtos.SalarySearchRow) => ({
            Id: item.individualId,
            IdentificationNumber: item.identificationNumber,
            EmployeeCode: item.employeeCode,
            FirstName: item.firstName,
            LastName: item.lastName,
            Race: item.race,
            Gender: item.gender,
            Disabled: item.isDisabled ? 'Yes' : 'No',
            TotalSalary: currencyFormatterNoDecimal(item.totalSalary),
            Actions: [
                isEditable ?
                    {
                        label: 'Edit Salaries',
                        action: () => {handleEdit(item.individualId)},
                        key: item.individualId.toString(),
                        icon: { color: 'info', name: 'edit' }
                    } :
                    {
                        label: 'View Salaries',
                        action: () => {handleEdit(item.individualId)},
                        key: item.individualId.toString(),
                        icon: { color: 'info', name: 'visibility' }
                    }
            ]

        }));

        return { columns: columns, rows: rows };

    }else {
        return { columns: columns, rows: [] };
    }
}


interface EmployeeSalariesConsolidationRow extends EmployeeSalariesRow {
    SourceScorecardName: string;
}

interface EmployeeSalariesConsolidationTable {
    columns: Array<TableColumn>;
    rows: Array<EmployeeSalariesConsolidationRow>;
}

export function EmployeeSalariesConsolidationWithActionsTableMapper(dataObject: SalaryDtos.SalarySearchRow[], handleEdit: (id: number) => void, isEditable: boolean): EmployeeSalariesConsolidationTable | undefined {
    const columns = [
        { Header: 'ID Number', accessor: 'IdentificationNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Name', accessor: 'FirstName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Surame', accessor: 'LastName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Race', accessor: 'Race', id:'RaceId', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Gender', accessor: 'Gender', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Disabled', accessor: 'Disabled', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Total Salary', accessor: 'TotalSalary', Cell: ({ value }: any) => <DefaultCell value={value}/>, disableSortBy: true },
        { Header: 'Source Scorecard', accessor: 'SourceScorecardName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item:SalaryDtos.SalarySearchRow) => ({
            Id: item.individualId,
            IdentificationNumber: item.identificationNumber,
            EmployeeCode: item.employeeCode,
            FirstName: item.firstName,
            LastName: item.lastName,
            Race: item.race,
            Gender: item.gender,
            Disabled: item.isDisabled ? 'Yes' : 'No',
            TotalSalary: currencyFormatterNoDecimal(item.totalSalary),
            SourceScorecardName: item.sourceScorecardName,
            Actions: [
                isEditable ?
                    {
                        label: 'Edit Salaries',
                        action: () => {handleEdit(item.individualId)},
                        key: item.individualId.toString(),
                        icon: { color: 'info', name: 'edit' }
                    } :
                    {
                        label: 'View Salaries',
                        action: () => {handleEdit(item.individualId)},
                        key: item.individualId.toString(),
                        icon: { color: 'info', name: 'visibility' }
                    }
            ]
            
        }));

        return { columns: columns, rows: rows };
        
    }else {
        return { columns: columns, rows: [] };
    }
}